<template>
    <section class="container">
      <div class="route">
        {{$locales.gestionanticipos.gestionanticipos}}
      </div>
      <div class="wide-window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.gestionanticipos.gestionanticipos}}</h1>
          <div class="form-group">
            <form class="window-form" @submit.prevent="aceptar">
              <!-- Primer campo -->
              <!-- Cabecera -->
              <!-- COMBO -->
              <label for="deudor">Deudor</label>
                  <md-field class="anchoCombo100">
                    <md-select class = "combo" name="deudor" v-model="model.deudor" id="deudor" placeholder="Seleccione un deudor" @md-selected="controlCamposEntrada">
                      <md-option v-for="pers in deudores" v-bind:key="pers.contractId"  :value="pers.contractId">{{pers.name}} - {{pers.contractId}}</md-option>
                    </md-select>
                  </md-field>

              <!-- Segundo campo -->
              <!-- Cabecera -->
              <label for="fechaDesde">Fecha vencimiento</label>
              <div class="compositeComponent">
                <!-- Input -->
                <md-datepicker :class = "(submitted && $v.model.fechaDesde.$invalid)?'invalid':''" id="fechaDesde" name="fechaDesde" v-model="model.fechaDesde" md-immediately><label class="insideLabel">Desde</label></md-datepicker>
                <md-datepicker :class = "(submitted && $v.model.fechaHasta.$invalid)?'invalid lastElement':''" id="fechaHasta" name="fechaHasta" v-model="model.fechaHasta" md-immediately><label class="insideLabel">Hasta</label></md-datepicker>
                <!-- Posibles errores de validacion -->
                <div class="error" v-if="submitted && $v.model.fechaDesde.$invalid">La fecha inicial no puede ser posterior a la fecha final</div>
              </div>
              <!-- Cabecera -->
              <label for="fechaAlta">Fecha alta</label>
              <div class="compositeComponent">
                <!-- Input -->
                <md-datepicker :class = "(submitted && $v.model.fechaAltaDesde.$invalid)?'invalid':''" id="fechaAltaDesde" name="fechaAltaDesde" v-model="model.fechaAltaDesde" md-immediately><label class="insideLabel">Desde</label></md-datepicker>
                <md-datepicker :class = "(submitted && $v.model.fechaAltaHasta.$invalid)?'invalid lastElement':''" id="fechaAltaHasta" name="fechaAltaHasta" v-model="model.fechaAltaHasta" md-immediately><label class="insideLabel">Hasta</label></md-datepicker>
                <!-- Posibles errores de validacion -->
                <div class="error" v-if="submitted && $v.model.fechaAltaDesde.$invalid">La fecha inicial no puede ser posterior a la fecha final</div>
              </div>
              <!-- Cabecera -->
              <label for="importeDesde">Importe</label>
              <div class="compositeComponent">
                <!-- Input -->
                <div :class = "(submitted && $v.model.importeDesde.$invalid)?'importe inputInvalid ':'importe inputComponent'">
                  <input  type="number" id="importeDesde" step="any" name="importeDesde" autocomplete="off" placeholder="Desde" v-model="model.importeDesde" @change="controlCamposEntrada"/>
                  <span class="icon">€  </span>
                </div>
                <!-- Input -->
                <div :class = "(submitted && $v.model.importeHasta.$invalid)?'importe inputInvalid  lastElement':'importe inputComponent lastElement'">
                  <input type="number" id="importeHasta" step="any" name="importeHasta" autocomplete="off" placeholder="Hasta" v-model="model.importeHasta" @change="controlCamposEntrada"/>
                  <span class="icon">€  </span>
                </div>
                <!-- Posibles errores de validacion -->
                <div class="error" v-if="submitted && !$v.model.importeDesde.lessThanToAmount">El importe mínimo no puede ser mayor al importe máximo</div>
                <div class="error" v-if="submitted && (!$v.model.importeDesde.maxLength || !$v.model.importeHasta.maxLength)">El campo debe tener como máximo 12 cifras</div>
              </div>
              <!-- Boton aceptar -->
              <input class="btnPrimary" type="submit" ref="myBtn" value="Aceptar">
            </form>
            <div class="output" v-if="submitted && confirmacion!='KO'">
              <md-list>
                <md-list-item :md-expand="expandCandidatas" :md-expanded.sync="expandedCandidatas">
                  <span class="md-list-item-text">Órdenes candidatas a ser anticipadas</span>
                  <md-list slot="md-expand">
                    <md-table v-model="ordenesCandidatas" @md-selected="onSelectCandidatas">
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                        <md-table-cell md-label="Orden" md-sort-by="id">{{ item.formats[0].value }}</md-table-cell>
                        <md-table-cell md-label="Cuenta" md-sort-by="title">{{ item.account }}</md-table-cell>
                        <!--<md-table-cell md-label="Deudor" md-sort-by="name"></md-table-cell>-->
                        <md-table-cell md-label="Importe" md-sort-by="email"><span v-if="item.amount" class="importeLista">{{ item.amount.amount }} {{ item.amount.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Fecha vcto." md-sort-by="gender">{{ item.expirationDate }}</md-table-cell>
                        <md-table-cell md-label="F. alta fact." md-sort-by="title">{{ item.comunicationDate }}</md-table-cell>
                        <md-table-cell md-label="Concepto" md-sort-by="title">{{ item.concept }}</md-table-cell>
                        <md-table-cell md-label="Comisión" md-sort-by="gender"><span v-if="item.commission" class="importeLista">{{ item.commission.amount }} {{ item.commission.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Importe IVA" md-sort-by="gender"><span v-if="item.fees" class="importeLista">{{ item.fees.amount }} {{ item.fees.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Tipo interés" md-sort-by="title">{{ item.interestType }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                    <div class="rowExcel">
                      <div @click="exportExcel('ordenesCandidatas')" class="downloadExcel">
                        <a id="excelIcon">Ñ</a>
                        <a id="textExcelIcon">Descargar Excel</a>
                      </div>
                    </div>
                  </md-list>
                </md-list-item>
              </md-list>
              <md-list>
                <md-list-item :md-expand="expandMarcadas" :md-expanded.sync="expandedMarcadas">
                  <span class="md-list-item-text">Órdenes marcadas</span>
                  <md-list slot="md-expand">
                    <md-table v-model="ordenesMarcadas" @md-selected="onSelectMarcadas">
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                        <md-table-cell md-label="Orden" md-sort-by="id">{{ item.formats[0].value }}</md-table-cell>
                        <md-table-cell md-label="Cuenta" md-sort-by="title">{{ item.account }}</md-table-cell>
                        <!--<md-table-cell md-label="Deudor" md-sort-by="name"></md-table-cell>-->
                        <md-table-cell md-label="Importe" md-sort-by="email"><span v-if="item.amount" class="importeLista">{{ item.amount.amount }} {{ item.amount.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Fecha vcto." md-sort-by="gender">{{ item.expirationDate }}</md-table-cell>
                        <md-table-cell md-label="F. alta fact." md-sort-by="title">{{ item.comunicationDate }}</md-table-cell>
                        <md-table-cell md-label="Concepto" md-sort-by="title">{{ item.concept }}</md-table-cell>
                        <md-table-cell md-label="Comisión" md-sort-by="gender"><span v-if="item.commission" class="importeLista">{{ item.commission.amount }} {{ item.commission.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Importe IVA" md-sort-by="gender"><span v-if="item.fees" class="importeLista">{{ item.fees.amount }} {{ item.fees.currency.code }}</span></md-table-cell>
                        <md-table-cell md-label="Tipo interés" md-sort-by="title">{{ item.interestType }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                    <div class="rowExcel">
                      <div @click="exportExcel('ordenesMarcadas')" class="downloadExcel">
                        <a id="excelIcon">Ñ</a>
                        <a id="textExcelIcon">Descargar Excel</a>
                      </div>
                    </div>
                    <div class="AdvancePaymentsButtons">
                      <input type="submit" class="btnPrimary separacion" @click="simulacion" value="Simular" :disabled="isDisabledSimulacion">
                      <input type="submit" class="btnPrimary" @click="anticipacion" value="Anticipar" :disabled="isDisabledSimulacion">
                    </div>
                  </md-list>
                </md-list-item>
              </md-list>
            </div>
          </div>
      </div>
    </section>
</template>

<script>
import {maxLength } from "vuelidate/lib/validators";
import format from 'date-fns/format';
import AdvancePaymentManagement from '../models/AdvancePaymentManagement';
import XLSX from 'xlsx/xlsx';
export default {
    name : 'AdvancePaymentManagementComponent',
    props: {
        columns: {
            type: Array,
            default: () => [
              {
                label: "Orden",
                field: "formats[0].value",
              },
              {
                label: "Cuenta",
                field: "account",
              },
              {
                label: "Importe",
                field: "amount.amount",
              },
              {
                label: "Fecha vcto.",
                field: "expirationDate",
              },
              {
                label: "F. alta fact.",
                field: "comunicationDate",
              },
              {
                label: "Concepto",
                field: "concept",
              },
              {
                label: "Comisión",
                field: "commission.amount",
              },
              {
                label: "Importe Iva",
                field: "fees.amount",
              },
              {
                label: "Tipo interés",
                field: "interestType",
              }]
        },
        sheetName: {
            type: String,
            default: 'SheetName'
        },
        fileType: {
            type: String,
            default: 'xlsx',
            validator: (val) => ['xlsx', 'xls'].includes(val)
        }
    },
    data(){
      return{
        ordenesCandidatas:new Array(),
        deudores:null, 
        expandMarcadas:false, //permite expandir o replegar la lista de marcadas en funcion de si tiene ordenes
        expandCandidatas:false, //permite expandir o replegar la lista de candidatas en funcion de si tiene ordenes
        expandedMarcadas:false, //expande o repliega la lista de marcadas en funcion de si tiene ordenes
        expandedCandidatas:false, //expande o repliega la lista de candidatas en funcion de si tiene ordenes
        ordenesMarcadas:new Array(),
        confirmacion:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        submitted: false,
        selected: {},
        pais: null,
        model : new AdvancePaymentManagement() //nuestro model contiene los datos de Entrada, es como el modelCriteria de TF
      }
    },
    computed : {
      isDisabledSimulacion: function() { 
        if(this.ordenesMarcadas.length>0){
          return false;
        }else{
          return true;
        }
      }
    },
    created: function(){ //llamada a /api-notifications/notifications/subscription para obtener los datos
      //consulta previa de deudores
      const baseURI = '/api-confirming/confirming/supplier/debtors';
      let loader = this.$loading.show();
      var ventana=this;
      this.$http.get(baseURI)
            .then((result) => {
              //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
              result.data.data.forEach(deudor => {
                deudor.contractId = deudor.contractId.replace(/^0+/, '');
              });
              this.deudores=result.data.data;
            })
            .catch(error => {
              var codError = error.response.data.result.errors[0].errorCode;
              var descError = error.response.data.result.errors[0].errorDescription;
              ventana.mensajeError = codError + " - " + descError;
              ventana.confirmacion = "KO";
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            })
            .then(function () {
              loader.hide();
            });
    },
    validations : { //aqui ponemos la validacion de cada input del html
      model : {
        fechaDesde: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaDesde!=null && this.model.fechaHasta!=null){
              return (this.model.fechaDesde<=this.model.fechaHasta);
            }else{
              return true;
            }
          }
        },
        fechaHasta: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaDesde!=null && this.model.fechaHasta!=null){
              return (this.model.fechaDesde<=this.model.fechaHasta);
            }else{
              return true;
            }
          }
        },
        fechaAltaDesde: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaAltaDesde!=null && this.model.fechaAltaHasta!=null){
              return (this.model.fechaAltaDesde<=this.model.fechaAltaHasta);
            }else{
              return true;
            }
          }
        },
        fechaAltaHasta: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaAltaDesde!=null && this.model.fechaAltaHasta!=null){
              return (this.model.fechaAltaDesde<=this.model.fechaAltaHasta);
            }else{
              return true;
            }
          }
        },
        importeDesde: {
          lessThanToAmount: function() { //validacion personalizada
            if(this.model.importeDesde!='' && this.model.importeDesde!=null  && this.model.importeHasta!='' && this.model.importeHasta!=null){
              return (parseFloat(this.model.importeDesde)<=parseFloat(this.model.importeHasta));
            }else{
              return true;
            }
          },
          maxLength: maxLength(12)
        },
        importeHasta: {
          lessThanToAmount: function() { //validacion personalizada
            if(this.model.importeDesde!='' && this.model.importeDesde!=null  && this.model.importeHasta!='' && this.model.importeHasta!=null){
              return (parseFloat(this.model.importeDesde)<=parseFloat(this.model.importeHasta));
            }else{
              return true;
            }
          },
          maxLength: maxLength(12)
        }
      }
    },
    mounted () {
       if(this.$route.params.deudor!=null){
          this.model.deudor = this.$route.params.deudor;
          this.model.fechaDesde = this.$route.params.fechaDesde;
          this.model.fechaHasta = this.$route.params.fechaHasta;
          this.model.fechaAltaDesde = this.$route.params.fechaAltaDesde;
          this.model.fechaAltaHasta = this.$route.params.fechaAltaHasta;
          this.model.importeDesde = this.$route.params.importeDesde;
          this.model.importeHasta = this.$route.params.importeHasta;
          this.deudores = this.$route.params.deudores;
          
          this.aceptar();
        }
    },
    methods: {
      simulacion(){
        this.$router.push({ name:'simulacionAnticipo', 
          params: { 
            deudor: this.model.deudor, 
            fechaDesde : this.model.fechaDesde, 
            fechaHasta : this.model.fechaHasta, 
            fechaAltaDesde : this.model.fechaAltaDesde, 
            fechaAltaHasta : this.model.fechaAltaHasta, 
            importeDesde : this.model.importeDesde, 
            importeHasta : this.model.importeHasta, 
            deudores : this.deudores 
          }
        });
      },
      controlCamposEntrada(){
        this.submitted=false;
        this.ordenesCandidatas=new Array();
        this.ordenesMarcadas=new Array();
      },
      anticipacion(){
        this.$router.push({ name:'anticipoOrdenes',
          params: { 
            deudor: this.model.deudor, 
            fechaDesde : this.model.fechaDesde, 
            fechaHasta : this.model.fechaHasta, 
            fechaAltaDesde : this.model.fechaAltaDesde, 
            fechaAltaHasta : this.model.fechaAltaHasta, 
            importeDesde : this.model.importeDesde, 
            importeHasta : this.model.importeHasta, 
            deudores : this.deudores 
          }
        });
      },
      onSelectCandidatas (item) {
        const index = this.ordenesCandidatas.indexOf(item);
        if (index > -1) { //esto es necesario para distinguir selecciones de deselecciones
          const ventana=this;
          const baseURI = '/api-confirming/confirming/suppliers/orders/'+item.id+'/mark';
          const options = {
                params: {
                    'deudorId':item.debtorLine,
                    'deudorIdentification':this.deudores.find(x => x.contractId === item.debtorLine).legalDocument
                }
              };
          let loader = this.$loading.show();
          this.$http.put(baseURI, null, options)
          .then(() => {
            //refresca la pagina
            this.ordenesCandidatas=new Array();
            this.ordenesMarcadas=new Array();
            this.consultaCandidatas();
            this.consultaMarcadas();
          })
          .catch(function (error) {
            if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
              ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
            }
            ventana.confirmacion='KO';
            window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
          })
          .then(function () {
            loader.hide();
          });
        }
      },
      onSelectMarcadas (item) {
        const index = this.ordenesMarcadas.indexOf(item);
        if (index > -1) { //esto es necesario para distinguir selecciones de deselecciones
          const ventana=this;
          const baseURI = '/api-confirming/confirming/suppliers/orders/'+item.id+'/unmark';
          const options = {
                params: {
                    'deudorId':item.debtorLine,
                    'deudorIdentification':this.deudores.find(x => x.contractId === item.debtorLine).legalDocument
                }
              };
          let loader = this.$loading.show();
          this.$http.put(baseURI,null, options)
          .then(() => {
            //refresca la pagina
            this.ordenesCandidatas=new Array();
            this.ordenesMarcadas=new Array();
            this.consultaCandidatas();
            this.consultaMarcadas();
          })
          .catch(function (error) {
            if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
              ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
            }else{ //si no, por defecto
              ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
            }
            ventana.confirmacion='KO';
            window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
          })
          .then(function () {
            loader.hide();
          });
        }
      },
      consultaCandidatas(){
      let dateFormat = 'yyyy-MM-dd';
            var ventana=this;
            //consulta de ordenes candidatas
            const baseURI = '/api-confirming/confirming/suppliers/orders';
            var fechaDesde=null;
            var fechaHasta=null;
            if(this.model.fechaDesde!=null){
              fechaDesde=format(this.model.fechaDesde, dateFormat);
            }
            if(this.model.fechaHasta!=null){
              fechaHasta=format(this.model.fechaHasta, dateFormat)
            }

            var fechaAltaDesde=null;
            var fechaAltaHasta=null;
            if(this.model.fechaAltaDesde!=null){
              fechaAltaDesde=format(this.model.fechaAltaDesde, dateFormat);
            }
            if(this.model.fechaAltaHasta!=null){
              fechaAltaHasta=format(this.model.fechaAltaHasta, dateFormat)
            }
            const options = {
              params: {
                  'deudor':this.model.deudor,
                  'dateFrom':fechaDesde,
                  'dateTo':fechaHasta,
                  'amountFrom':this.model.importeDesde,
                  'amountTo':this.model.importeHasta,
                  'dateContractFrom':fechaAltaDesde,
                  'dateContractTo':fechaAltaHasta
              }
            };
            let loader = this.$loading.show();
            this.$http.get(baseURI,options)
            .then((result) => {
              //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
              result.data.data.forEach(element => {
                      if(element.formats[0]!=null){
                        element.formats[0].value=element.formats[0].value.replace(/^0+/, '');
                      }
                      if(element.debtorLine!=null){
                        element.debtorLine=element.debtorLine.replace(/^0+/, '');
                      }
                      if(element.amount!=null){
                        element.amount.currency.code=this.formatearMoneda(element.amount.currency.code);
                      }
                      if(element.commission!=null){
                        element.commission.currency.code=this.formatearMoneda(element.commission.currency.code);
                      }

                      if(element.fees!=null){
                        element.fees.currency.code=this.formatearMoneda(element.fees.currency.code);
                      }
                      
                      let dateFormat = 'dd/MM/yyyy';
                      if(element.expirationDate!=null){
                        var date = new Date(element.expirationDate);
                        element.expirationDate=format(date, dateFormat);
                      }
                      if(element.comunicationDate!=null){
                        var date2 = new Date(element.comunicationDate);
                        element.comunicationDate=format(date2, dateFormat);
                      }
                      ventana.ordenesCandidatas.push(element);
                    });
                    ventana.confirmacion=null;
                  if(ventana.ordenesMarcadas.length>0){
                    ventana.expandMarcadas=true;
                    ventana.expandedMarcadas=true;
                  }else{
                    ventana.expandMarcadas=false;
                    ventana.expandedMarcadas=false;
                  }
                  if(ventana.ordenesCandidatas.length>0){
                    ventana.expandCandidatas=true;
                    ventana.expandedCandidatas=true;
                  }else{
                    ventana.expandCandidatas=false;
                    ventana.expandedCandidatas=false;
                  }
            })
            .catch(error => {
              if(error.response) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                ventana.mensajeError = codError + " - " + descError;
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
              
            })
            .then(function () {
              loader.hide();
            });
            
      },
      consultaMarcadas(){
      let dateFormat = 'yyyy-MM-dd';
        var ventana=this;
        //consulta de ordenes marcadas
            const baseURI = '/api-confirming/confirming/supplier/markedOrders';
            
            var fechaDesde=null;
            var fechaHasta=null;
            if(this.model.fechaDesde!=null){
              fechaDesde=format(this.model.fechaDesde, dateFormat);
            }
            if(this.model.fechaHasta!=null){
              fechaHasta=format(this.model.fechaHasta, dateFormat)
            }

            var fechaAltaDesde=null;
            var fechaAltaHasta=null;
            if(this.model.fechaAltaDesde!=null){
              fechaAltaDesde=format(this.model.fechaAltaDesde, dateFormat);
            }
            if(this.model.fechaAltaHasta!=null){
              fechaAltaHasta=format(this.model.fechaAltaHasta, dateFormat)
            }
            const options = {
              params: {
                  'debtorId':this.model.deudor,
                  'debtorIdentification':(this.model.deudor!=null ? this.deudores.find(x => x.contractId === this.model.deudor).legalDocument : ""),
                  'debtorIdentificationType':(this.model.deudor!=null ? this.deudores.find(x => x.contractId === this.model.deudor).legalDocumentType: ""),
                  'dateFrom':fechaDesde,
                  'dateTo':fechaHasta,
                  'amountFrom':this.model.importeDesde,
                  'amountTo':this.model.importeHasta,
                  'dateContractFrom':fechaAltaDesde,
                  'dateContractTo':fechaAltaHasta
              }
            };
            let loader = this.$loading.show();
            this.$http.get(baseURI,options)
            .then((result) => {
              //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
              result.data.data.forEach(element => {
                      if(element.formats[0]!=null){
                        element.formats[0].value=element.formats[0].value.replace(/^0+/, '');
                      }
                      if(element.debtorLine!=null){
                        element.debtorLine=element.debtorLine.replace(/^0+/, '');
                      }
                      if(element.amount!=null){
                        element.amount.currency.code=this.formatearMoneda(element.amount.currency.code);
                      }
                      if(element.commission!=null){
                        element.commission.currency.code=this.formatearMoneda(element.commission.currency.code);
                      }

                      if(element.fees!=null){
                        element.fees.currency.code=this.formatearMoneda(element.fees.currency.code);
                      }

                      let dateFormat = 'dd/MM/yyyy';
                      if(element.expirationDate!=null){
                        var date = new Date(element.expirationDate);
                        element.expirationDate=format(date, dateFormat);
                      }
                      if(element.comunicationDate!=null){
                        var date2 = new Date(element.comunicationDate);
                        element.comunicationDate=format(date2, dateFormat);
                      }
                      ventana.ordenesMarcadas.push(element);
                    });
                    ventana.confirmacion=null;
                  if(ventana.ordenesMarcadas.length>0){
                    ventana.expandMarcadas=true;
                    ventana.expandedMarcadas=true;
                  }else{
                    ventana.expandMarcadas=false;
                    ventana.expandedMarcadas=false;
                  }
                  if(ventana.ordenesCandidatas.length>0){
                    ventana.expandCandidatas=true;
                    ventana.expandedCandidatas=true;
                  }else{
                    ventana.expandCandidatas=false;
                    ventana.expandedCandidatas=false;
                  }
            })
            .catch(error => {
              if(error.response) {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                ventana.mensajeError = codError + " - " + descError;
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
              
            })
            .then(function () {
              loader.hide();
            });
      },
      formatearMoneda(coin) {
        if(coin=="EUR") {
          coin = "€"
          return coin;
        }else if(coin=="DOL") {
          coin = "$"
          return coin;
        }
      },
      aceptar() {
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            this.ordenesCandidatas=new Array();
            this.ordenesMarcadas=new Array();
            this.consultaCandidatas();
            this.consultaMarcadas();
          }
      },
      exportExcel(boton) {
        let createXLSLFormatObj = [];
        let newXlsHeader = [];
        let vm = this;
        let mutableData;
        if(boton == 'ordenesCandidatas') {
          mutableData = vm.ordenesCandidatas;
        } else if(boton == 'ordenesMarcadas') {
          mutableData = vm.ordenesMarcadas;
        }
       
        vm.columns.map(column => {
            newXlsHeader.push(column.label);
        });

        createXLSLFormatObj.push(newXlsHeader);
        mutableData.map(value => {
            let innerRowData = [];
            vm.columns.map(val => {
              let fieldValue = value[val.field];
              if (val.field.split('.').length > 1) {
                fieldValue = this.getNestedValue(value, val.field);
              }
              if (val.dataFormat && typeof val.dataFormat === 'function') {
                    innerRowData.push(val.dataFormat(fieldValue));
                } else {
                    innerRowData.push(fieldValue);
                }
            });
            createXLSLFormatObj.push(innerRowData);
        });

        let fileName = boton + "." + vm.fileType;

        let ws_name = vm.sheetName;

        let wb = XLSX.utils.book_new(),
            ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, fileName);
      },
      getNestedValue(object, string) {
        string = string.replace(/\[(\w+)\]/g, '.$1');
        string = string.replace(/^\./, '');
        let a = string.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
          let k = a[i];
          if (k in object) {
            object = object[k];
          } else {
            return;
          }
        }
        return object;
      }
    }
}
</script>